import { useEffect } from 'react';
import LeafSpinner from './LeafSpinner';
import Paragraph from './Paragraph';
export enum SPINNER_TYPE {
  IN_SCREEN = 'IN_SCREEN',
  ON_SCREEN = 'ON_SCREEN',
}
interface Props {
  text?: string;
  type?: SPINNER_TYPE;
}
const Spinner = ({
  text,
  type = SPINNER_TYPE.ON_SCREEN
}: Props) => {
  useEffect(() => {
    document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, []);
  return <div className={`top-0 left-0 flex justify-center flex-col fixed bg-[rgba(0,0,0,0.4)] z-[100] ${type === 'IN_SCREEN' ? ' w-full h-full' : ' w-screen h-screen'}`} data-testid="spinner-div" data-sentry-component="Spinner" data-sentry-source-file="Spinner.tsx">
      {text ? <Paragraph className="text-center p-4"> {text}</Paragraph> : null}
      <LeafSpinner data-sentry-element="LeafSpinner" data-sentry-source-file="Spinner.tsx" />
    </div>;
};
export default Spinner;